import { render } from "./AdmissionInstances.vue?vue&type=template&id=d40542b2"
import script from "./AdmissionInstances.vue?vue&type=script&lang=js"
export * from "./AdmissionInstances.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__